import { render, staticRenderFns } from "./localuploadFile.vue?vue&type=template&id=dcfc2124"
import script from "./localuploadFile.vue?vue&type=script&lang=js"
export * from "./localuploadFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports